import { ICustomerContextCustomerFragment } from "../contexts/customer/CustomerContext.generated";
import { IApplicationStatus, ICustomerStatus, IProduct } from "../generated/types";

export const ACTIVE_CUSTOMER_STATUSES = [ICustomerStatus.Open];
export const ACTIVE_APPLICATION_STATUSES = [
    IApplicationStatus.Approved,
    IApplicationStatus.AwaitingDocuments,
    IApplicationStatus.Pending,
    IApplicationStatus.PendingReview,
    IApplicationStatus.SubmissionError,
];

export function isCustomerActive(customer: ICustomerContextCustomerFragment): boolean {
    return ACTIVE_CUSTOMER_STATUSES.includes(customer.status) || customer.products.includes(IProduct.Supersheets);
}
